export const USER_INFORMATION_MODAL_WIDTH = "min(51.2rem, calc(100vw - 2rem))";
export const USER_PERMISSIONS_MODAL_WIDTH = "min(60.8rem, calc(100vw - 2rem))";
export const ABOUT_USER_PERMISSIONS_MODAL_WIDTH = "min(45.6rem, calc(100vw - 2rem))";
